import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { checkStoreState, setInitialStoreState } from '../../../../../common/utils';
import { PartnerItemFacade } from './partner-item.facade';

@Injectable({
  providedIn: 'root',
})
export class PartnerItemGuard {
  constructor(private partnerItemFacade: PartnerItemFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      params: { partnerId },
    } = route;
    return checkStoreState(this.partnerItemFacade, partnerId);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.partnerItemFacade);
  }
}
